<div class="blog-page">
  <div class="container">
    <!-- Header -->
    <div class="blog-header">
      <span class="section-tag">Blog</span>
      <h1 class="page-title">SEO & Indexing Insights</h1>
      <p class="page-subtitle">Expert guides, tips, and best practices for faster indexing and better rankings.</p>
    </div>

    <!-- Loading -->
    <div *ngIf="loading" class="loading-state">
      <div class="spinner spinner-lg"></div>
      <p>Loading articles...</p>
    </div>

    <!-- Featured post -->
    <a *ngIf="!loading && posts.length > 0" [routerLink]="['/blog', posts[0].slug]" class="featured-post">
      <div class="featured-content">
        <span class="badge badge-primary" *ngIf="posts[0].category_name">{{ posts[0].category_name }}</span>
        <h2>{{ posts[0].title }}</h2>
        <p>{{ posts[0].excerpt }}</p>
        <div class="featured-meta">
          <span>{{ formatDate(posts[0].published_at) }}</span>
          <span>·</span>
          <span>{{ posts[0].reading_time }} min read</span>
        </div>
      </div>
      <div class="featured-arrow">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
      </div>
    </a>

    <!-- Filters -->
    <div class="blog-filters" *ngIf="!loading">
      <div class="search-input">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
        <input type="text" placeholder="Search articles..." [(ngModel)]="searchQuery" (input)="onFilterChange()" />
      </div>
      <div class="category-tabs">
        <button class="category-tab" [class.active]="!selectedCategory" (click)="selectCategory('')">All</button>
        <button *ngFor="let cat of categories" class="category-tab" [class.active]="selectedCategory === cat.slug" (click)="selectCategory(cat.slug)">
          {{ cat.name }}
        </button>
      </div>
    </div>

    <!-- Posts grid -->
    <div class="blog-grid" *ngIf="!loading && posts.length > 1">
      <a *ngFor="let post of posts.slice(1)" [routerLink]="['/blog', post.slug]" class="blog-card">
        <div class="blog-card-image" *ngIf="post.featured_image?.medium">
          <img [src]="post.featured_image?.medium" [alt]="post.title" loading="lazy" />
        </div>
        <div class="blog-card-image-placeholder" *ngIf="!post.featured_image?.medium">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" opacity="0.3"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
        </div>
        <div class="blog-card-body">
          <span class="blog-card-category" *ngIf="post.category_name">{{ post.category_name }}</span>
          <h3 class="blog-card-title">{{ post.title }}</h3>
          <p class="blog-card-excerpt">{{ post.excerpt }}</p>
          <div class="blog-card-meta">
            <span>{{ formatDate(post.published_at) }}</span>
            <span>·</span>
            <span>{{ post.reading_time }} min read</span>
          </div>
        </div>
      </a>
    </div>

    <!-- Empty state -->
    <div *ngIf="!loading && posts.length === 0" class="empty-state">
      <p>No articles found.</p>
    </div>

    <!-- Pagination -->
    <div class="pagination" *ngIf="!loading && totalPages > 1">
      <button class="btn btn-secondary btn-sm" (click)="prevPage()" [disabled]="currentPage === 1">Previous</button>
      <span class="pagination-info">Page {{ currentPage }} of {{ totalPages }}</span>
      <button class="btn btn-secondary btn-sm" (click)="nextPage()" [disabled]="currentPage === totalPages">Next</button>
    </div>
  </div>
</div>
